import { IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import { ICreativeSize } from '@/Interfaces/Creatives/CreativeSize.interface';

export default class CreativeSizeService {
  public static toGroupControlOptions(creativeSizes: ICreativeSize[]): IGroupedControlOption[] {
    return (creativeSizes ?? []).map(size => ({
      value: size.id,
      label: size.name,
      groupLabel: size.category,
      groupValue: size.category,
    }));
  }
}
